export default function getResource(label) {
    const resources = {
        savedForLaterTitle: 'Enregistré pour plus tard',
        viewAll: 'Tout afficher',
        remove: 'Retirer',
        moveToBasket: 'Déplacer dans le panier',
        moved: 'Moved',
        limitExceededTitle: 'Limit Reached for This Item',
        maxItemsReachedMessage: 'Max number of products saved. To add more, please remove products first.',
        ok: 'OK',
        genericErrorTitle: 'Error',
        genericErrorMessage: 'An error occurred. Please try again.',
        gotIt: 'Got It',
        itemShip: 'This item is not available in your country.'
    };

    return resources[label];
}
